<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header">
        <div class="modal-window-heading">
          <h3 class="icon-heading small" v-if="this.kontrakt">Skriv ut etiketter for kontrakt #{{this.kontrakt.Kontraktnr}}</h3>
          <h3 class="icon-heading small" v-else-if="this.objekt">Skriv ut etiketter</h3>
        </div>
      </div>

      <div class="modal-window-body gray">
        <TheLoader :active="$store.getters.isFormLoading" :small="true"/>
        <fieldset v-if="!$store.getters.isFormLoading">
          <div class="grid-x grid-padding-x">
            <div class="cell">
              <a href="javascript:;" class="button action" @click="addRow">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Ny rad</span>
              </a>
            </div>
          </div>
          <div class="grid-x grid-padding-x" v-for="item in items" v-bind:key="item.index">
            <TheSelectInput v-model="item.labelType" containerClassName="cell large-3" label="Etikett type" :name="'labelType_' + item.index" required v-validate="'required'" data-vv-validate-on="input" :items="labelTypesOptions" @input="onLabelTypeChange(item)" :customErrorMessage="'Påkrevd'"/>
            <TheSelectInput v-model="item.printerId" containerClassName="cell auto" label="Skriver" :name="'printerId_' + item.index" required v-validate="'required'" data-vv-validate-on="input" :items="printerListOptions(item)" :customErrorMessage="'Påkrevd'"/>
            <TheIntegerInput v-model="item.labelCount" containerClassName="cell large-2" label="Antall" :name="'labelCount_' + item.index" maxlength="3" required v-validate="'required|min_value:1|max_value:100'" :customErrorMessage="'Påkrevd (1-100)'"/>
            <div class="cell shrink">
              <div class="input-container">
                <label>&nbsp;</label>
                <a href="javascript:;" v-if="item.index === 0" class="button action glyph-only disabled"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett</span></a>
                <a href="javascript:;" v-else class="button action glyph-only" @click="delRow(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett</span></a>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a href="javascript:;" @click="$emit('close')" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="handleSubmit()" class="button primary submit large">Skriv ut</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading" disabled>Skriver ut...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Skriv ut</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="$emit('close')">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
import ObjektService from '@/services/ObjektService'
import KontraktService from '@/services/KontraktService'

export default {
  name: 'PrintLabelModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    objekt: {
      type: Object,
      required: false,
      default: null
    },
    kontrakt: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      index: 0,
      items: [],
      defaultLabelCount: 1,
      printerList: [],
      labelTypesOptions: []
    }
  },
  created () {
    if (!this.objekt && !this.kontrakt) {
      this.$helpers.showErrorAlert('Feil', 'Må laste modal med objekt eller kontrakt')
      this.$emit('close')
    } else {
      this.setFormLoading(true)
      this.fetch()
    }

    if (this.objekt && this.objekt.Antalletikett) {
      this.defaultLabelCount = this.objekt.Antalletikett
    }

    if (this.objekt && this.objekt.Antalletikett <= 2 && (this.objekt.Kategori === 'UL' || this.objekt.Kategori === 'ZL')) {
      this.defaultLabelCount = 2
    }
  },
  methods: {
    onLabelTypeChange: function (item) {
      item.printerId = null
    },
    printerListOptions: function (item) {
      let found = this.items.find(x => x.index === item.index)

      return this.printerList.filter((i) => {
        return i.key === null || i.labeltypes.includes(found.labelType)
      })
    },
    fetch: function () {
      InstillingerService('printer').dropdown()
        .then((response) => {
          this.printerList = response.data
          this.printerList.unshift({ key: null, val: 'Velg skriver', labeltypes: [] })

          // Just hardcoded label types - as this won't change...
          this.labelTypesOptions = [
            { key: 'Small', val: 'Smykker' }, // Previously called "Liten"
            { key: 'Medium', val: 'Liten' }, // Previously called "Smykker"
            { key: 'Large', val: 'Stor med QR' },
            { key: 'Wine', val: 'Vinetikett' },
            { key: 'Artsafe', val: 'Artsafe' }
          ]

          this.labelTypesOptions.unshift({ key: null, val: 'Velg etikett type', disabled: true })
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)

          // Add first row
          this.loadLocalStorage()
        })
    },
    addRow: function () {
      this.items.push({
        index: this.index++,
        labelCount: this.defaultLabelCount,
        labelType: null,
        printerId: null
      })
    },
    delRow: function (item) {
      let found = this.items.findIndex(x => x.index === item.index)

      if (found !== -1) {
        this.items.splice(found, 1)
      }
    },
    loadLocalStorage: function () {
      let rows = null

      if (localStorage.last_label_setup) {
        try {
          rows = JSON.parse(localStorage.last_label_setup)
          rows.forEach(r => {
            this.items.push({
              index: this.index++,
              labelCount: this.defaultLabelCount,
              labelType: r.labelType,
              printerId: r.printerId
            })
          })
        } catch (e) {
          console.log('Something wrong with local storage')
        }
      }

      if (!this.items || this.items.length < 1) {
        this.items.push({
          index: this.index++,
          labelCount: this.defaultLabelCount,
          labelType: null,
          printerId: null
        })
      }
    },
    saveLocalStorage: function () {
      let lsArray = []

      // Loop - we don't want the vue reactivity stuff...
      this.items.forEach(i => {
        lsArray.push({
          labelCount: this.defaultLabelCount,
          labelType: i.labelType,
          printerId: i.printerId
        })
      })

      localStorage.last_label_setup = JSON.stringify(lsArray)
    },

    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            let post = {
              labels: this.items
            }

            if (this.kontrakt) {
              KontraktService.printLabels(this.kontrakt.Kontraktnr, post)
                .then((response) => {
                  this.$helpers.showSuccessAlert('Ok', 'Etiketter er sendt til skriverkøen')
                  this.saveLocalStorage()
                })
                .catch((e) => {
                  console.log(e)
                  this.$helpers.showErrorAlert('Feil', 'Etiketter kunne ikke sendes til skriverkøen')
                })
                .then(() => {
                  this.setFormProcessing(false)
                })
            } else if (this.objekt) {
              ObjektService.printLabels(this.objekt.Objektid, post)
                .then((response) => {
                  this.$helpers.showSuccessAlert('Ok', 'Etiketter er sendt til skriverkøen')
                  this.saveLocalStorage()
                })
                .catch((e) => {
                  console.log(e)
                  this.$helpers.showErrorAlert('Feil', 'Etiketter kunne ikke sendes til skriverkøen')
                })
                .then(() => {
                  this.setFormProcessing(false)
                })
            }
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/PrintLabelsModal.vue